import React, { memo } from 'react';
import { motion } from 'framer-motion';
import { Lock, Download } from 'lucide-react';
import { trackAddToCart } from '../../lib/metaPixel';
export function CTAButton({
  className = '',
  showTrustBadges = false,
  label = '¡SÍ, QUIERO MI MEMORIA BLINDADA AHORA!',
  href
}: {
  className?: string;
  showTrustBadges?: boolean;
  label?: string;
  href?: string;
}) {
  const isExternal = Boolean(href);
  const handleScrollClick = (e: React.MouseEvent) => {
    e.preventDefault();
    const target = document.getElementById('oferta');
    if (target) {
      target.scrollIntoView({
        behavior: 'smooth',
        block: 'start'
      });
    }
  };
  const handleExternalClick = () => {
    trackAddToCart({
      content_name: 'Memoria Blindada',
      content_ids: ['memoria-blindada'],
      value: 17.0,
      currency: 'USD'
    });
    // Allow default navigation to continue
  };
  return <div className={`flex flex-col items-center ${className}`} data-id="element-206">
      <motion.a href={isExternal ? href : '#oferta'} {...isExternal ? {
      target: '_blank',
      rel: 'noopener noreferrer',
      onClick: handleExternalClick
    } : {
      onClick: handleScrollClick
    }} whileHover={{
      scale: 1.02
    }} whileTap={{
      scale: 0.98
    }} className="inline-block w-full md:w-auto bg-gold-500 text-navy-900 font-bold text-lg md:text-xl py-5 px-8 md:px-12 rounded-xl shadow-lg hover:bg-gold-400 transition-colors text-center cursor-pointer" data-id="element-207">
        {label}
      </motion.a>

      {showTrustBadges && <div className="flex items-center justify-center gap-4 mt-4 text-sm text-charcoal-700 font-medium" data-id="element-208">
          <div className="flex items-center gap-1.5" data-id="element-209">
            <Lock className="w-4 h-4 text-gold-600" data-id="element-210" />
            <span data-id="element-211">Compra segura</span>
          </div>
          <span className="text-gray-300" data-id="element-212">•</span>
          <div className="flex items-center gap-1.5" data-id="element-213">
            <Download className="w-4 h-4 text-gold-600" data-id="element-214" />
            <span data-id="element-215">Acceso inmediato</span>
          </div>
        </div>}
    </div>;
}